import React from "react";

function MagicWand({ width = 17, height = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 17 16"
    >
      <path
        fill="#fff"
        d="M7.75.152c.031-.093.125-.156.25-.156.094 0 .188.063.219.156l.437 1.188 1.188.437a.235.235 0 01.156.22c0 .124-.063.218-.156.25l-1.188.437L8.22 3.84A.235.235 0 018 3.996c-.125 0-.219-.062-.25-.156l-.438-1.156-1.187-.438C6.031 2.215 6 2.121 6 1.996c0-.094.031-.187.125-.219l1.188-.437L7.75.152zm7.719.313l1.062 1.062a1.49 1.49 0 010 2.125L4.625 15.56a1.49 1.49 0 01-2.125 0l-1.063-1.063a1.49 1.49 0 010-2.125L13.345.465a1.49 1.49 0 012.125 0zm-1.063 1.031L10.97 4.934l1.094 1.093 3.406-3.437-1.063-1.094zm-10.844 13L11 7.09 9.906 5.996 2.5 13.434l1.063 1.062zM.22 3.684L2 2.996l.656-1.75c.031-.156.188-.25.344-.25.125 0 .281.094.313.25L4 2.996l1.75.688c.156.03.25.187.25.312 0 .156-.094.313-.25.344L4 4.996l-.688 1.781c-.03.125-.187.22-.312.22-.156 0-.313-.095-.344-.22L2 4.997.219 4.34C.062 4.309 0 4.152 0 3.996c0-.125.063-.281.219-.312zm11 8L13 10.996l.656-1.75c.031-.156.188-.25.344-.25.125 0 .281.094.313.25l.687 1.75 1.75.688c.156.03.25.187.25.312 0 .156-.094.313-.25.344l-1.75.656-.688 1.781c-.03.125-.187.22-.312.22-.156 0-.313-.095-.344-.22L13 12.997l-1.781-.657c-.156-.031-.219-.188-.219-.344 0-.125.063-.281.219-.312z"
      ></path>
    </svg>
  );
}

export default MagicWand;
